import * as React from "react";
const SvgAdd = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	xmlSpace: "preserve",
	viewBox: "0 0 48.2 48.2",
	width: "1em",
	height: "1em",
	...props
}, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("path", {
	id: "add_svg__a",
	d: "M-126.7-434.3c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5-.7 1.5-1.5 1.5-1.5-.6-1.5-1.5m-1.2-4c0-1.4-.7-1.5-1.7-1.5h-5.3c-.9 0-1.7.1-1.7 1.5h-2.9c-2.2 0-4.3 2.2-4.3 4.4v8.8c0 2.2 2.2 4.4 4.3 4.4h14.4c2.2 0 4.3-2.2 4.3-4.4v-8.8c0-2.2-2.2-4.4-4.3-4.4zm-4.1 4.5c2.4 0 4.3 2.1 4.3 4.6s-2.1 4.4-4.5 4.4-4.5-2-4.5-4.5 2.4-4.5 4.7-4.5"
})), /* @__PURE__ */ React.createElement("clipPath", { id: "add_svg__b" }, /* @__PURE__ */ React.createElement("use", {
	xlinkHref: "#add_svg__a",
	style: { overflow: "visible" }
})), /* @__PURE__ */ React.createElement("g", { style: { clipPath: "url(#add_svg__b)" } }, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("path", {
	id: "add_svg__c",
	d: "M-170.7-1146.8h375v2319h-375z"
})), /* @__PURE__ */ React.createElement("clipPath", { id: "add_svg__d" }, /* @__PURE__ */ React.createElement("use", {
	xlinkHref: "#add_svg__c",
	style: { overflow: "visible" }
})), /* @__PURE__ */ React.createElement("path", {
	d: "M-148.7-444.8h33v29h-33z",
	style: {
		clipPath: "url(#add_svg__d)",
		fill: "currentColor"
	}
})), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("path", {
	id: "add_svg__e",
	d: "M-126.7-434.3c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5-.7 1.5-1.5 1.5-1.5-.6-1.5-1.5m-1.2-4c0-1.4-.7-1.5-1.7-1.5h-5.3c-.9 0-1.7.1-1.7 1.5h-2.9c-2.2 0-4.3 2.2-4.3 4.4v8.8c0 2.2 2.2 4.4 4.3 4.4h14.4c2.2 0 4.3-2.2 4.3-4.4v-8.8c0-2.2-2.2-4.4-4.3-4.4zm-4.1 4.5c2.4 0 4.3 2.1 4.3 4.6s-2.1 4.4-4.5 4.4-4.5-2-4.5-4.5 2.4-4.5 4.7-4.5"
})), /* @__PURE__ */ React.createElement("clipPath", { id: "add_svg__f" }, /* @__PURE__ */ React.createElement("use", {
	xlinkHref: "#add_svg__e",
	style: { overflow: "visible" }
})), /* @__PURE__ */ React.createElement("g", { style: { clipPath: "url(#add_svg__f)" } }, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("path", {
	id: "add_svg__g",
	d: "M-170.7-1146.8h375v2319h-375z"
})), /* @__PURE__ */ React.createElement("clipPath", { id: "add_svg__h" }, /* @__PURE__ */ React.createElement("use", {
	xlinkHref: "#add_svg__g",
	style: { overflow: "visible" }
})), /* @__PURE__ */ React.createElement("path", {
	d: "M-148.7-444.8h33v29h-33z",
	style: {
		clipPath: "url(#add_svg__h)",
		fill: "currentColor"
	}
})), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("path", {
	id: "add_svg__i",
	d: "M-126.7-434.3c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5-.7 1.5-1.5 1.5-1.5-.6-1.5-1.5m-1.2-4c0-1.4-.7-1.5-1.7-1.5h-5.3c-.9 0-1.7.1-1.7 1.5h-2.9c-2.2 0-4.3 2.2-4.3 4.4v8.8c0 2.2 2.2 4.4 4.3 4.4h14.4c2.2 0 4.3-2.2 4.3-4.4v-8.8c0-2.2-2.2-4.4-4.3-4.4zm-4.1 4.5c2.4 0 4.3 2.1 4.3 4.6s-2.1 4.4-4.5 4.4-4.5-2-4.5-4.5 2.4-4.5 4.7-4.5"
})), /* @__PURE__ */ React.createElement("clipPath", { id: "add_svg__j" }, /* @__PURE__ */ React.createElement("use", {
	xlinkHref: "#add_svg__i",
	style: { overflow: "visible" }
})), /* @__PURE__ */ React.createElement("g", { style: { clipPath: "url(#add_svg__j)" } }, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("path", {
	id: "add_svg__k",
	d: "M-170.7-1146.8h375v2319h-375z"
})), /* @__PURE__ */ React.createElement("clipPath", { id: "add_svg__l" }, /* @__PURE__ */ React.createElement("use", {
	xlinkHref: "#add_svg__k",
	style: { overflow: "visible" }
})), /* @__PURE__ */ React.createElement("path", {
	d: "M-148.7-444.8h33v29h-33z",
	style: {
		clipPath: "url(#add_svg__l)",
		fill: "currentColor"
	}
})), /* @__PURE__ */ React.createElement("path", {
	d: "M25.1 6.8C15.1 6.8 7 14.9 7 24.9S15.1 43 25.1 43s18.1-8.1 18.1-18.1S35.1 6.8 25.1 6.8m10.6 20q0 .15 0 0l-8.6.1s-.1 0-.1.1v8.5s0 .1-.1.1H23s-.1 0-.1-.1V27s0-.1-.1-.1h-8.5s-.1 0-.1-.1v-3.9s0-.1.1-.1H23s.1 0 .1-.1v-8.5s0-.1.1-.1H27s.1 0 .1.1v8.5s0 .1.1.1h8.5s.1 0 .1.1v3.9z",
	style: { fill: "currentColor" }
}));
export default SvgAdd;
